import { ApiActionStatus, AppState, Destinations, Facets, Filters, Hotel, HotelResults, PaleState, Results } from '../interfaces';

const defaultHotel: Hotel = {
    id: '',
    name: '',
    tripAdvisorId: '',
    rating: 0,
    country: '',
    region: '',
    destination: '',
    facilities: [],
    activities: [],
    distanceToBeach: 0,
    distanceToCity: 0,
    imagePaths: [],
};

export const defaultHotelResults: HotelResults = {
    numberOfOffers: 0,
    totalPages: 0,
    currentPage: 0,
    offers: [],
    sortOptions: [],
    defaultSort: '',
    status: ApiActionStatus.NOT_STARTED,
};

const defaultFacets: Facets = {
    location: [],
    originAirport: [],
    charterSuppliers: [],
    nonCharterSuppliers: [],
    activities: [],
    facilities: [],
    meals: [],
};

const defaultResults: Results = {
    numberOfHotels: 0,
    totalPages: 0,
    currentPage: 0,
    offers: [],
    facets: defaultFacets,
    sortOptions: [],
    defaultSort: '',
    status: ApiActionStatus.NOT_STARTED,
};

const defaultDestinations: Destinations = {
    list: [],
    tree: {},
};

export const defaultFilters: Filters = {
    origin: '',
    destinations: defaultDestinations,
    meals: {},
    facilities: {},
    activities: {},
    keywords: '',
    suppliers: {},
    rating: {},
    travelMonths: [],
    ignoredFilters: [],
    departureDate: { flexibility: 3 },
    returnDate: { flexibility: 3 },
};

const defaultAppState: AppState = {
    filtersOpen: false,
};

const defaultState: PaleState = {
    hotel: defaultHotel,
    hotelResults: defaultHotelResults,
    results: defaultResults,
    filters: defaultFilters,
    appState: defaultAppState,
};

export default defaultState;
